import { render, staticRenderFns } from "./AvatarV2.vue?vue&type=template&id=0c01e8af&scoped=true&"
import script from "./AvatarV2.vue?vue&type=script&lang=js&"
export * from "./AvatarV2.vue?vue&type=script&lang=js&"
import style0 from "./AvatarV2.vue?vue&type=style&index=0&id=0c01e8af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01e8af",
  null
  
)

export default component.exports